import BlogPostCategoriesSettingsNew from 'client/components/core/Sidebar/components/Settings/entities/BlogPostCategoriesSettingsNew'
import BlogPostDateSettingsNew from 'client/components/core/Sidebar/components/Settings/entities/BlogPostDateSettingsNew'
import BlogPostTitleSettingsNew from 'client/components/core/Sidebar/components/Settings/entities/BlogPostTitleSettingsNew'
import ButtonSettingsNew from 'client/components/core/Sidebar/components/Settings/entities/button-settings'
import RecaptchaSettings from 'client/components/core/Sidebar/components/Settings/entities/RecaptchaSettings'
import { SearchResultsSettings } from 'client/components/core/Sidebar/components/Settings/entities/search-results-settings'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogContentPlaceholderInterface } from 'common/types/entities/BlogContentPlaceholderInterface'
import { BlogPostCategoriesInterface } from 'common/types/entities/BlogPostCategoriesInterface'
import { BlogPostContentPlaceholderInterface } from 'common/types/entities/BlogPostContentPlaceholderInterface'
import { BlogPostDateInterface } from 'common/types/entities/BlogPostDateInterface'
import { BlogPostListingInterface } from 'common/types/entities/BlogPostListingInterface'
import { BlogPostTitleInterface } from 'common/types/entities/BlogPostTitleInterface'
import { BreadcrumbsInterface } from 'common/types/entities/BreadcrumbsInterface'
import { ContactUsInterface } from 'common/types/entities/ContactUsInterface'
import EntityInterface from 'common/types/entities/EntityInterface'
import { LatestBlogPostsCarouselInterface } from 'common/types/entities/LatestBlogPostsCarouselInterface'
import { LatestBlogPostsInterface } from 'common/types/entities/LatestBlogPostsInterface'
import { RecaptchaInterface } from 'common/types/entities/RecaptchaInterface'
import { SearchResultsInterface } from 'common/types/entities/search-results-interface'
import React from 'react'
import { SearchSettings } from 'src/editor/shared/entities/search/search-settings'
import { ActionButtonEntityInterface } from 'src/shared/entities/button/action-button.schema'
import { ContactUsButtonEntityInterface } from 'src/shared/entities/contact-us-button/contact-us-button-entity.schema'
import { ContactUsFieldEntityInterface } from 'src/shared/entities/contact-us-field/contact-us-field-entity.schema'
import { AttachmentsInterface } from 'src/shared/types/entities/attachments-interface'
import { SearchInterface } from 'src/shared/types/entities/search-interface'
import BlogLatestPostsSettings from '../blog-page/settings/BlogLatestPostsSettings'
import BlogPostListingSettings from '../blog-page/settings/BlogPostListingSettings'
import LatestBlogPostsCarouselSettings from '../blog-page/settings/LatestBlogPostsCarouselSettings'
import AttachmentsSettings from '../contact-us/settings/AttachmentsSettings'
import ButtonSettings from '../contact-us/settings/ButtonSettings'
import ContactUsFieldSettings from '../contact-us/settings/ContactUsFieldSettings'
import ContactUsSettings from '../contact-us/settings/ContactUsSettings'
import createCommonEntitySettings from '../createCommonEntitySettings'
import BlogContentPlaceholderSettings from './settings/BlogContentPlaceholderSettings'
import BlogPostContentPlaceholderSettings from './settings/BlogPostContentPlaceholderSettings'
import BreadcrumbsSettings from './settings/BreadcrumbsSettings'

function createSettingsForBlog(
  entity: EntityInterface,
  defaultEntity?: EntityInterface,
) {
  switch (entity.type) {
    case EntityTypeEnum.BlogPostListing:
      return (
        <BlogPostListingSettings
          entity={entity as BlogPostListingInterface}
          defaultEntity={defaultEntity as BlogPostListingInterface}
        />
      )
    case EntityTypeEnum.SearchResults:
      return (
        <SearchResultsSettings
          entity={entity as SearchResultsInterface}
          defaultEntity={defaultEntity as SearchResultsInterface}
        />
      )
    case EntityTypeEnum.Search:
      return (
        <SearchSettings
          entity={entity as SearchInterface}
          defaultEntity={defaultEntity as SearchInterface}
        />
      )
    case EntityTypeEnum.LatestBlogPosts:
      return (
        <BlogLatestPostsSettings
          entity={entity as LatestBlogPostsInterface}
          defaultEntity={defaultEntity as LatestBlogPostsInterface}
        />
      )
    case EntityTypeEnum.Breadcrumbs:
      return (
        <BreadcrumbsSettings
          entity={entity as BreadcrumbsInterface}
          defaultEntity={defaultEntity as BreadcrumbsInterface}
        />
      )
    case EntityTypeEnum.BlogPostDate:
      return (
        <BlogPostDateSettingsNew
          entity={entity as BlogPostDateInterface}
          defaultEntity={defaultEntity as BlogPostDateInterface}
        />
      )
    case EntityTypeEnum.BlogPostCategories:
      return (
        <BlogPostCategoriesSettingsNew
          entity={entity as BlogPostCategoriesInterface}
          defaultEntity={defaultEntity as BlogPostCategoriesInterface}
        />
      )
    case EntityTypeEnum.BlogPostTitle:
      return (
        <BlogPostTitleSettingsNew
          entity={entity as BlogPostTitleInterface}
          defaultEntity={defaultEntity as BlogPostTitleInterface}
        />
      )
    case EntityTypeEnum.BlogContentPlaceholder:
      return (
        <BlogContentPlaceholderSettings
          entity={entity as BlogContentPlaceholderInterface}
          defaultEntity={defaultEntity as BlogContentPlaceholderInterface}
        />
      )
    case EntityTypeEnum.BlogPostContentPlaceholder:
      return (
        <BlogPostContentPlaceholderSettings
          entity={entity as BlogPostContentPlaceholderInterface}
          defaultEntity={defaultEntity as BlogPostContentPlaceholderInterface}
        />
      )
    case EntityTypeEnum.LatestBlogPostsCarousel:
      return (
        <LatestBlogPostsCarouselSettings
          entity={entity as LatestBlogPostsCarouselInterface}
          defaultEntity={defaultEntity as LatestBlogPostsCarouselInterface}
        />
      )
    case EntityTypeEnum.ContactUs:
      return (
        <ContactUsSettings
          entity={entity as ContactUsInterface}
          defaultEntity={defaultEntity as ContactUsInterface}
        />
      )
    case EntityTypeEnum.Button:
      return (
        <ButtonSettingsNew
          entity={entity as ActionButtonEntityInterface}
          defaultEntity={defaultEntity as ActionButtonEntityInterface}
        />
      )
    case EntityTypeEnum.ContactUsButton:
      return (
        <ButtonSettings
          entity={entity as ContactUsButtonEntityInterface}
          defaultEntity={defaultEntity as ContactUsButtonEntityInterface}
        />
      )
    case EntityTypeEnum.ContactUsField:
      return (
        <ContactUsFieldSettings
          entity={entity as ContactUsFieldEntityInterface}
          defaultEntity={defaultEntity as ContactUsFieldEntityInterface}
        />
      )
    case EntityTypeEnum.Recaptcha:
    case EntityTypeEnum.ContactUsRecaptcha:
      return (
        <RecaptchaSettings
          entity={entity as RecaptchaInterface}
          defaultEntity={defaultEntity as RecaptchaInterface}
        />
      )
    case EntityTypeEnum.Attachments:
      return (
        <AttachmentsSettings
          entity={entity as AttachmentsInterface}
          defaultEntity={defaultEntity as AttachmentsInterface}
        />
      )
    default:
      return createCommonEntitySettings(entity, defaultEntity)
  }
}

export default createSettingsForBlog
